import * as React from 'react';

import styles from './Navigation.css';
import { NavigationBar } from './NavigationBar';
import { NavigationFixed } from './NavigationFixed';
import { INavigationDispatchProps, INavigationStoreProps } from './container';
import { getOffsetTop } from './helpers';

interface INaviftionState {
  useNavigationFixed: boolean;
}

type TProps = INavigationStoreProps & INavigationDispatchProps;

export class Navigation extends React.Component<TProps, INaviftionState> {
  private container = React.createRef<HTMLDivElement>();
  public state = {
    useNavigationFixed: false,
  };

  public componentDidMount() {
    this.handleScroll();
    window.addEventListener('scroll', this.handleScroll);
  }

  public componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  public render() {
    const { links, isFat } = this.props;
    const { useNavigationFixed } = this.state;

    return (
      <div ref={this.container} className={styles['container']}>
        <NavigationFixed isActive={useNavigationFixed} />
        <NavigationBar links={links} isFat={isFat} />
      </div>
    );
  }

  private handleScroll = () => {
    const { setNavigationMenuVisibility } = this.props;

    if (this.container.current) {
      const useNavigationFixed = window.pageYOffset > getOffsetTop(this.container.current);

      if (useNavigationFixed && !this.state.useNavigationFixed) {
        this.setState({ useNavigationFixed: true });
        setNavigationMenuVisibility(true);
      }

      if (!useNavigationFixed && this.state.useNavigationFixed) {
        this.setState({ useNavigationFixed: false });
        setNavigationMenuVisibility(false);
      }
    }
  };
}
